import { useStyle } from '@/classify';
import Icon from '@/components/Icon';
import { useCallback } from 'react';
import { ChevronDown as ArrowDown, ChevronUp as ArrowUp } from 'react-feather';
import { useAccordionContext } from './accordion';
import defaultClasses from './section.module.css';

const Section = props => {
  const { children, id, title, isShowIcon = true, ...restProps } = props;

  // Remove isOpen from restProps to avoid having it in the root container
  delete restProps.isOpen;

  const { handleSectionToggle, openSectionIds } = useAccordionContext();

  const handleSectionToggleWithId = useCallback(() => handleSectionToggle(id), [handleSectionToggle, id]);

  const isOpen = openSectionIds.has(id);
  const titleIconSrc = isOpen ? ArrowUp : ArrowDown;
  const titleIcon = isShowIcon ? (
    <Icon
      src={titleIconSrc}
      size={24}
    />
  ) : null;

  const classes = useStyle(defaultClasses, props.classes);
  const contentsContainerClass = isOpen ? classes.contents_container : classes.contents_container_closed;

  return (
    <div
      className={classes.root}
      {...restProps}
    >
      <button
        aria-expanded={isOpen}
        className={classes.title_container}
        data-cy='Section-titleContainer'
        onClick={handleSectionToggleWithId}
        type='button'
      >
        <div className={classes.title_wrapper}>
          <div className={classes.title}>{title}</div>
          {titleIcon}
        </div>
      </button>
      <div className={contentsContainerClass}>{children}</div>
    </div>
  );
};

export default Section;
